import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

import CardButton from "../../Components/Buttons/card-button";

import renderAccountDetails from "../../Organisms/Modals/Banking/account-details";
import renderRequestVirtualCard from "../../Organisms/Modals/Virtual Card/request-virtual-card";
import renderVerifyToViewVirtualCard from "../../Organisms/Modals/Virtual Card/verify-to-view-virtual-card";
import renderCashOutUsingPaymentEntity from "../../Organisms/Modals/Funding Instruments/cash-out-using-payment-entity";
import renderBankStatements from "../../Organisms/Modals/Banking/bank-statements";

import { useModalContext } from "../../Contexts/ModalContext";

import { hasSVDVirtualCard, isSVDApproved } from "../../Utils/helpers";

import {
  BankInfo,
  BankingOutline,
  Card,
  // Cards,
  Out,
  Recurring,
  Statement,
  SupportThin,
  Thunder,
} from "../../Assets/Icons";

export default function BankingServices({ stakeDebit = {}, payrollAccountsData = {} }) {
  const modalContext = useModalContext();
  const navigate = useNavigate();

  const IsSVDApproved = useMemo(() => {
    return isSVDApproved(stakeDebit?.data);
  }, [stakeDebit?.data]);

  const isPayrollConnected = useMemo(() => {
    return payrollAccountsData?.data?.data?.accounts?.length > 0;
  }, [payrollAccountsData]);

  const handleManageCardsClick = () => {
    if (hasSVDVirtualCard(stakeDebit)) {
      // All values contain a non-empty value
      renderVerifyToViewVirtualCard(modalContext);
    } else {
      // At least one value is empty
      renderRequestVirtualCard(modalContext);
    }
  };

  const handleOnCashOutClick = () => {
    if (!IsSVDApproved) {
      renderCashOutUsingPaymentEntity(modalContext);
    } else {
      navigate("/cash-out");
    }
  };

  return (
    <div className="banking-service-buttons row gx-sm-5 gx-0">
      <div className="col-sm-6 col-12">
        <CardButton
          title="Connected Bank Accounts"
          Icon={BankingOutline}
          onClick={navigate.bind(this, "/banking/connected-accounts")}
        />
      </div>

      {IsSVDApproved && (
        <>
          <div className="col-sm-6 col-12">
            <CardButton
              title="Recurring Deposits"
              Icon={Recurring}
              onClick={navigate.bind(this, "/banking/recurring-deposits")}
            />
          </div>

          {isPayrollConnected && (
            <div className="col-sm-6 col-12">
              <CardButton
                title="Express Paycheck"
                Icon={Thunder}
                onClick={navigate.bind(this, "/banking/direct-deposit")}
              />
            </div>
          )}

          <div className="col-sm-6 col-12">
            <CardButton
              title="Bank Statements"
              Icon={Statement}
              onClick={renderBankStatements.bind(this, modalContext)}
            />
          </div>

          <div className="col-sm-6 col-12">
            <CardButton title="Manage Cards" Icon={Card} onClick={handleManageCardsClick} />
          </div>

          <div className="col-sm-6 col-12">
            <CardButton
              title="Account and routing number"
              Icon={BankInfo}
              onClick={renderAccountDetails.bind(this, modalContext, stakeDebit?.data)}
            />
          </div>

          <div className="col-sm-6 col-12">
            <CardButton
              title="Banking Limits"
              Icon={SupportThin}
              onClick={navigate.bind(this, "/banking/banking-limits")}
            />
          </div>
        </>
      )}

      {/* {isAstraAccountConnected && (
        <div className="col-sm-6 col-12">
          <CardButton title="Debit Cards" Icon={Cards} onClick={navigate.bind(this, "/banking/debit-cards")} />
        </div>
      )} */}

      <div className="col-sm-6 col-12">
        <CardButton title="Cash Out" Icon={Out} onClick={handleOnCashOutClick} />
      </div>
    </div>
  );
}
